const E="USER_FILES",S="USER_AVATAR_FILES";export{S as USER_AVATAR_FILES,E as USER_FILE_CATEGORY};